/** Az ársáv geometriája: minden érték 0–100 százalék a közös skálán. */
export interface ArSavBemenet { min: number; max: number; kozep: number; skalaMin: number; skalaMax: number }
export interface ArSavGeometria { balSzazalek: number; szelessegSzazalek: number; kozepSzazalek: number }

const LEGKISEBB_SZELESSEG = 1;

function vag(x: number): number {
  return Math.min(100, Math.max(0, x));
}

export function arSavGeometria({ min, max, kozep, skalaMin, skalaMax }: ArSavBemenet): ArSavGeometria {
  const span = skalaMax - skalaMin;
  if (!(span > 0)) throw new RangeError(`Érvénytelen ársáv-skála: ${skalaMin}–${skalaMax}`);
  const szazalek = (x: number) => vag(((x - skalaMin) / span) * 100);
  const bal = szazalek(min);
  const jobb = szazalek(max);
  return {
    balSzazalek: bal,
    szelessegSzazalek: Math.max(LEGKISEBB_SZELESSEG, jobb - bal),
    kozepSzazalek: szazalek(kozep),
  };
}

/**
 * Több lead sávjához közös skála: a legkisebb min és a legnagyobb max, 10% ráhagyással.
 * Üres listára null (nincs mihez skálát számolni).
 */
export function kozosSkala(savok: ReadonlyArray<{ min: number; max: number }>): { skalaMin: number; skalaMax: number } | null {
  if (savok.length === 0) return null;
  const alsó = Math.min(...savok.map((s) => s.min));
  const felső = Math.max(...savok.map((s) => s.max));
  const rahagyas = Math.max((felső - alsó) * 0.1, Math.abs(felső) * 0.05, 1);
  return { skalaMin: Math.max(0, alsó - rahagyas), skalaMax: felső + rahagyas };
}
